import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';
import { Countertop, CountertopResponse, mapCountertopsToBusinessObject } from 'cloud-shared-lib';
import { map, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CountertopsService {
  constructor(private http: HttpClient) {}

  getCountertops(orderId: number): Observable<Countertop[]> {
    if (!isNaN(+orderId)) {
      return this.http
        .get<CountertopResponse[]>(ApiLinks.api + `countertops/order/${orderId}`)
        .pipe(map(c => mapCountertopsToBusinessObject(c)));
    } else {
      return of([]);
    }
  }
}
